export function FeatureIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 62 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.77"
        d="M51.7781 36.4347C51.7781 47.8341 42.5265 57.0984 31.1271 57.0984C20.4775 57.0984 11.7215 49.0541 10.5904 38.7222C10.5777 38.6586 10.565 38.6078 10.565 38.5443C9.52294 32.1266 11.0225 21.782 12.179 15.4786C12.7 12.6701 15.7627 11.1705 18.2917 12.4922C19.0542 12.8989 19.8675 13.3309 20.7317 13.7884C22.4346 11.1959 24.1375 8.79406 25.6625 6.69719C28.3567 2.98635 33.8848 2.98635 36.579 6.69719C42.7044 15.1101 51.7781 28.8605 51.7781 36.4347Z"
        fill="#4DD4D4"
      />
      <path
        d="M43.8862 37.7184C43.8862 45.1147 37.8879 51.113 30.4916 51.113C23.0954 51.113 17.097 45.1147 17.097 37.7184C17.097 33.6645 21.1256 26.8655 24.7602 21.5407C27.5179 17.4995 33.4781 17.4995 36.2358 21.5407C39.8704 26.8655 43.8989 33.6645 43.8989 37.7184H43.8862Z"
        fill="#077878"
      />
      <path
        d="M30.479 31.2244V42.7127"
        stroke="white"
        strokeWidth="2.55"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2232 36.9685H24.7476"
        stroke="white"
        strokeWidth="2.55"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
